import React from "react";

export type AthleteSecondarySidebarPanelProps = {
    collapsed: boolean;
    onToggle: () => void;
    children: React.ReactNode;
};

function ChevronIcon({ direction }: { direction: "left" | "right" }) {
    return (
        <svg
            className="athlete-secondary-sidebar-chevron-icon"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
        >
            {direction === "left" ? (
                <path
                    d="M10.5 3.5 5.5 8l5 4.5"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ) : (
                <path
                    d="M5.5 3.5 10.5 8l-5 4.5"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            )}
        </svg>
    );
}

export default function AthleteSecondarySidebarPanel({
    collapsed,
    onToggle,
    children,
}: AthleteSecondarySidebarPanelProps) {
    if (collapsed) {
        return (
            <button
                type="button"
                className="athlete-secondary-sidebar-expand-tab"
                onClick={onToggle}
                aria-label="Expand athlete navigation"
                aria-expanded={false}
                data-testid="athlete-secondary-sidebar-expand"
            >
                <ChevronIcon direction="right" />
            </button>
        );
    }

    return (
        <div className="athlete-secondary-sidebar athlete-admin-secondary-sidebar">
            <div className="athlete-secondary-sidebar-header">
                <button
                    type="button"
                    className="athlete-secondary-sidebar-collapse-btn"
                    onClick={onToggle}
                    aria-label="Collapse athlete navigation"
                    aria-expanded
                    data-testid="athlete-secondary-sidebar-collapse"
                >
                    <ChevronIcon direction="left" />
                </button>
            </div>
            {children}
        </div>
    );
}
